import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../../okio-parent-okio/okio/Buffer.mjs';
import { Companion_getInstance3d08n7snrwep7 as Companion_getInstance } from '../ExecutionContext.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var HttpMethod_Get_instance;
var HttpMethod_Post_instance;
var HttpMethod_entriesInitialized;
function HttpMethod_initEntries() {
  if (HttpMethod_entriesInitialized)
    return Unit_instance;
  HttpMethod_entriesInitialized = true;
  HttpMethod_Get_instance = new (HttpMethod())('Get', 0);
  HttpMethod_Post_instance = new (HttpMethod())('Post', 1);
}
var HttpMethodClass;
function HttpMethod() {
  if (HttpMethodClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'HttpMethod');
    HttpMethodClass = $;
  }
  return HttpMethodClass;
}
var HttpHeaderClass;
function HttpHeader() {
  if (HttpHeaderClass === VOID) {
    class $ {
      constructor(name, value) {
        this.t49_1 = name;
        this.u49_1 = value;
      }
      toString() {
        return 'HttpHeader(name=' + this.t49_1 + ', value=' + this.u49_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.t49_1);
        result = imul(result, 31) + getStringHashCode(this.u49_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HttpHeader()))
          return false;
        if (!(this.t49_1 === other.t49_1))
          return false;
        if (!(this.u49_1 === other.u49_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'HttpHeader');
    HttpHeaderClass = $;
  }
  return HttpHeaderClass;
}
function _get_hasBody__xziwnf($this) {
  return !($this.w49_1 == null) || !($this.x49_1 == null);
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(statusCode) {
        this.v49_1 = statusCode;
        this.w49_1 = null;
        this.x49_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.y49_1 = ArrayList().p2();
      }
      z49(bodySource) {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.check' call
        if (!!_get_hasBody__xziwnf(this)) {
          var message = 'body() can only be called once';
          throw IllegalStateException().o(toString(message));
        }
        this.w49_1 = bodySource;
        return this;
      }
      j49(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.y49_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = new (HttpHeader())(name, value);
        tmp0.i2(element);
        return this;
      }
      l49(headers) {
        // Inline function 'kotlin.apply' call
        this.y49_1.u2(headers);
        return this;
      }
      c38() {
        return new (HttpResponse())(this.v49_1, this.y49_1, this.w49_1, this.x49_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var HttpResponseClass;
function HttpResponse() {
  if (HttpResponseClass === VOID) {
    class $ {
      constructor(statusCode, headers, bodySource, bodyString) {
        this.a4a_1 = statusCode;
        this.b4a_1 = headers;
        this.c4a_1 = bodySource;
        this.d4a_1 = bodyString;
      }
      e4a() {
        var tmp0_elvis_lhs = this.c4a_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp1_safe_receiver = this.d4a_1;
          var tmp_0;
          if (tmp1_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = (new (Buffer())()).m3z(tmp1_safe_receiver);
          }
          tmp = tmp_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'HttpResponse');
    HttpResponseClass = $;
  }
  return HttpResponseClass;
}
var BuilderClass_0;
function Builder_0() {
  if (BuilderClass_0 === VOID) {
    class $ {
      constructor(method, url) {
        this.e49_1 = method;
        this.f49_1 = url;
        this.g49_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.h49_1 = ArrayList().p2();
        this.i49_1 = Companion_getInstance().f43_1;
      }
      k49(body) {
        // Inline function 'kotlin.apply' call
        this.g49_1 = body;
        return this;
      }
      j49(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.h49_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = new (HttpHeader())(name, value);
        tmp0.i2(element);
        return this;
      }
      l49(headers) {
        // Inline function 'kotlin.apply' call
        this.h49_1.u2(headers);
        return this;
      }
      s44(executionContext) {
        // Inline function 'kotlin.apply' call
        this.i49_1 = this.i49_1.t44(executionContext);
        return this;
      }
      c38() {
        return new (HttpRequest())(this.e49_1, this.f49_1, this.h49_1, this.g49_1, this.i49_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass_0 = $;
  }
  return BuilderClass_0;
}
var HttpRequestClass;
function HttpRequest() {
  if (HttpRequestClass === VOID) {
    class $ {
      constructor(method, url, headers, body, executionContext) {
        this.f4a_1 = method;
        this.g4a_1 = url;
        this.h4a_1 = headers;
        this.i4a_1 = body;
        this.j4a_1 = executionContext;
      }
      k4a(method, url) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (Builder_0())(method, url);
        if (!(this.i4a_1 == null)) {
          this_0.k49(this.i4a_1);
        }
        this_0.l49(this.h4a_1);
        this_0.s44(this.j4a_1);
        return this_0;
      }
      l4a(method, url, $super) {
        method = method === VOID ? this.f4a_1 : method;
        url = url === VOID ? this.g4a_1 : url;
        return $super === VOID ? this.k4a(method, url) : $super.k4a.call(this, method, url);
      }
    }
    initMetadataForClass($, 'HttpRequest');
    HttpRequestClass = $;
  }
  return HttpRequestClass;
}
function HttpMethod_Get_getInstance() {
  HttpMethod_initEntries();
  return HttpMethod_Get_instance;
}
function HttpMethod_Post_getInstance() {
  HttpMethod_initEntries();
  return HttpMethod_Post_instance;
}
//region block: exports
export {
  HttpHeader as HttpHeader1d7ldebjomr00,
  Builder_0 as Builder2ocxamygt14i4,
  Builder as Builder1mo34du82b3c6,
  HttpMethod_Get_getInstance as HttpMethod_Get_getInstance139ackgavp29i,
  HttpMethod_Post_getInstance as HttpMethod_Post_getInstance1acsve6b42vet,
};
//endregion

//# sourceMappingURL=Http.mjs.map
